<template>
  <div class="mt-1 mb-0 pb-0">
    <div class="d-flex justify-content-end">
      <div v-if="!noAdd" class="mr-2" style="width:100px">
        <add-button @click="$emit('doAddNew')"></add-button>
      </div>
      <div v-if="!noEdit" class="mr-2" style="width:100px">
        <edit-button @click="$emit('doEdit')" :countChecked="countChecked"></edit-button>
      </div>
      <div v-if="!noDelete" class="mr-2" style="width:100px">
        <delete-button @click="doDeleteRow" :countChecked="countChecked"></delete-button>
      </div>
      <div v-if="!noSearch">
        <base-input
          class="input-group-alternative mb-0 text-right"
          placeholder="Nhập nội dung để tìm..."
          v-model="keyword"
          addon-right-icon="fa fa-search"
        >
        </base-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'control-mini',
  data() {
    return {
      keyword: ''
    };
  },
  props: {
    countChecked: {
      type: Number,
      default: 0
    },
    noDelete: {
      default: false
    },
    noEdit: {
      default: false
    },
    noAdd: {
      default: false
    },
    noSearch: {
      default: false
    }
  },
  methods: {
    doDeleteRow: function() {
      var self = this;
      self.$emit('doDelete');
    }
  },
  watch: {
    keyword: function() {
      clearTimeout(this.timerSearch);
      this.timerSearch = setTimeout(() => {
        this.$emit('search', this.keyword);
      }, 500);
    }
  }
};
</script>
